import type { FetchError } from 'ofetch';
import type { HttpClient, HttpResponse } from '@/utils/HttpClient';
import type { Breadcrumb, BreadcrumbErrorFetch } from '@/types/page';
import type { ProductsMenu, ProductsMenuFetchError } from '@/types/products';
import { LanguageConfig } from '~/types';

type Sentry = {
  captureException: (error: string[]) => void;
};

type FetchData = {
  errors: string[];
  result: Breadcrumb[];
};

export const ProductService = (httpClient: HttpClient, $sentry: Sentry) => ({
  fetchBreadcrumbs(slug: string, includeImages: boolean | undefined = undefined, assortment = 'default') {
    return httpClient<Breadcrumb, BreadcrumbErrorFetch>({
      endpoint: `/breadcrumbs/${slug}`,
      params: {
        images: includeImages,
        assortment,
      },
    });
  },
  async fetchBreadcrumbsBatch(slugs: string[], includeImages: boolean | undefined = undefined, assortment = 'default') {
    const { data, error } = await httpClient<FetchData, string>({
      endpoint: '/breadcrumbs/search',
      method: 'POST',
      body: {
        breadcrumbs: slugs,
        images: includeImages,
        assortment,
      },
    });
    if (error) return { error };
    if ((data as FetchData).errors.length) $sentry.captureException((data as FetchData).errors);
    return { data: (data as FetchData).result };
  },
  fetchMenu(assortment?: string) {
    return httpClient<ProductsMenu[], ProductsMenuFetchError>({ endpoint: '/menu', params: { assortment } });
  },
  fetchLanguageConfig(): Promise<HttpResponse<LanguageConfig, FetchError>> {
    return httpClient<LanguageConfig, FetchError>({ endpoint: '/language-config' });
  },
});
